import React from "react";
import "../assets/styles/home.css";

const Home = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="home-hero">
        {/*
        <img
          src={require("../assets/images/HeroImage.png")}
          alt="Welcome Illustration"
          className="hero-image"
        />
        */}
        <h1>Welcome to SeeingMoney</h1>
        <p>Explore our financial tools and resources to take control of your money.</p>
      </section>

      {/* Tools Preview Section */}
      <section className="tools-preview">
        <div className="tool-card-home">
          {/* Image for Compound Interest Calculator */}
          <img
            src={require("../assets/images/Compound Interest Calculator 2.PNG")}
            alt="Compound Interest Growth"
            className="tool-preview-image-home"
          />
          <h2>Compound Interest Calculator</h2>
          <p>Visualize how your savings grow with compound interest.</p>
          <a href="/compound-interest" className="cta-button-home">
            Try Now
          </a>
        </div>

        <div className="tool-card-home">
          {/* Image for Financial Independence Calculator */}
          <img
            src={require("../assets/images/FI Calculator 2.PNG")}
            alt="Financial Independence Projection"
            className="tool-preview-image-home"
          />
          <h2>Financial Independence Calculator</h2>
          <p>Plan your journey to early retirement and financial independence.</p>
          <a href="/financial-independence" className="cta-button-home">
            Try Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
